import type { ReactElement } from 'react';
import { CmarkdownLabelText } from '../Cmarkdowntext/CmarkdownLabelText';
import { FontWeight } from '@/theme/typography';
import { TREEMAP_LABEL_TEXT_ALIGN_CENTER, TREEMAP_LABEL_TEXT_STYLE, TREEMAP_LABEL_WRAPPER_STYLE, TREEMAP_VALUE_BASE_STYLE, type TreemapLeafCellModel, } from './treemap-cell-node-model';
interface TreemapLeafCellProps {
    model: TreemapLeafCellModel;
}
export function TreemapLeafCell({ model, }: TreemapLeafCellProps): ReactElement {
    return (
    <div data-el="Cmarkdowntreemap/TreemapLeafCell/Root" style={model.rootStyle}>
      {model.showLabel ? (<CmarkdownLabelText dataElScope="Cmarkdowntreemap/TreemapLeafCell" content={model.label} size={12} weight={FontWeight.SemiBold} textAlign={TREEMAP_LABEL_TEXT_ALIGN_CENTER} style={TREEMAP_LABEL_WRAPPER_STYLE} paragraphStyle={{ marginBottom: 0, minWidth: 0, justifyContent: 'center' }} textStyle={{ ...TREEMAP_LABEL_TEXT_STYLE, color: model.labelColor }}/>) : null}
      {model.showValue ? (<span style={{ ...TREEMAP_VALUE_BASE_STYLE, color: model.valueColor }}>
          {model.formattedValue}
        </span>) : null}
    </div>
    );
}
